import { API_BASE_URL } from './index';

const normalizeUrl = (url: string): string => url.replace(/\/+$/, '');

const ensurePathSuffix = (url: string, suffix: string): string => {
  const normalized = normalizeUrl(url);
  if (normalized.toLowerCase().endsWith(suffix.toLowerCase())) {
    return normalized;
  }
  return `${normalized}${suffix}`;
};

const toOrigin = (url: string): string => {
  try {
    const parsed = new URL(url);
    return normalizeUrl(`${parsed.protocol}//${parsed.host}`);
  } catch {
    return normalizeUrl(url);
  }
};

const normalizedApiBase = normalizeUrl(API_BASE_URL);
const rawApiOverride = import.meta.env.VITE_CWY_TWILIO_SERVER_API_URL?.trim();
const rawSocketOverride = import.meta.env.VITE_TWILIO_SOCKET_URL?.trim();

const TWILIO_API_URL = ensurePathSuffix(
  rawApiOverride && rawApiOverride.length > 0 ? rawApiOverride : normalizedApiBase,
  '/twilio'
);

const TWILIO_SOCKET_URL = rawSocketOverride && rawSocketOverride.length > 0
  ? normalizeUrl(rawSocketOverride)
  : toOrigin(TWILIO_API_URL);

export { TWILIO_API_URL, TWILIO_SOCKET_URL };
